module.exports = __webpack_public_path__ + "img/chongzhi.0706a656.png";